import S from 'string';
import { mapKeysDeep } from './lodashUtils';

function camelizeKey(value, key) {
  return S(key).camelize().s;
}

function underscoreKey(value, key) {
  return S(key).underscore().s;
}

function assignDeeplyTo(that, data) {
  Object.assign(that, mapKeysDeep(data, transformKey));
}

function updateQueryParams(paramsWithValues) {
  const searchParams = new window.URLSearchParams(window.location.search);
  paramsWithValues.forEach(pair => {
    searchParams.set(pair.key, pair.value);
  });
  window.location.search = searchParams.toString();
}

function isFeatureToggleActive(featureToggle) {
  return !!window.FEATURE_TOGGLES[featureToggle]
}

export { camelizeKey, underscoreKey, assignDeeplyTo, updateQueryParams, isFeatureToggleActive };
